// @flow

import React, { PureComponent } from 'react';

import { dynamicClassName } from 'utils/dynamicClassName';
import { getPublicAssets } from 'utils/assetsUtils';

import CardThumbnail from 'containers/fragments/CardThumbnailContainer';
import HubCard from 'components/hub/HubCard';

import type { CardMenuElementType } from 'types/Settings';

type Props = {
  title: string,
  cards: CardMenuElementType[],
  isBottomRow: boolean,
};

export default class Navigation extends PureComponent<Props> {
  static defaultProps = {
    isBottomRow: false,
  };

  renderCards = () => {
    const { cards } = this.props;
    return cards.map<any>(({ object_id, title, texte_cta, object_slug, featured_image, description = ''}, index) => {
      let img = featured_image.src || getPublicAssets('/img/trash/card.jpg');
      if (featured_image.sizes && featured_image.sizes.medium_large && featured_image.sizes.medium_large.src) {
        img = featured_image.sizes.medium_large.src;
      }
      if (index > 0 &&
        featured_image.sizes &&
        featured_image.sizes['post-thumbnail'] &&
        featured_image.sizes['post-thumbnail'].src
      ) {
        img = featured_image.sizes['post-thumbnail'].src;
      }
      const className = dynamicClassName('col col-md-4 mb-2 mb-md-0');
      index === 0 ? className.add('col-lg-6') : className.add('col-lg-3');
      return (
        <div
          key={object_id}
          className={className.build()}>
          {index > 0 &&
          <CardThumbnail
            url={`/${object_slug}`}
            title={title}
            desc={description}
            backgroundUrl={{src: img}}
            linkLabel={texte_cta} />
          }
          {index === 0 &&
          <HubCard
            link={`/${object_slug}`}
            title={title}
            description={description}
            img={img}
            label={texte_cta} />
          }
        </div>
      );
    });
  };

  render() {
    const { title, isBottomRow } = this.props;
    const classNames = (!isBottomRow && 'row mb-6 mb-md-7 mb-lg-8') || 'row';
    return (
      <>
        <h2 className='mb-3'>{title}</h2>
        <div className={classNames}>
          {this.renderCards()}
        </div>
      </>
    );
  }
}
